import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { addLocale, locale, PrimeReactProvider } from 'primereact/api';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext.tsx';

const queryClient = new QueryClient();

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://d369a158823e22db83d6f7cacc47eebe@o4510427369897984.ingest.us.sentry.io/4510431544606720",
  sendDefaultPii: true,
  enableLogs: true,
  replaysSessionSampleRate: 0.1,
  environment: import.meta.env.VITE_MODE,
  replaysOnErrorSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration()],
});

locale("pt");
addLocale("pt", {
  clear: "Limpar",
  today: "Hoje",
  dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
  dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
  dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
  monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  dateFormat: "dd/mm/yy",
  firstDayOfWeek: 1
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PrimeReactProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </PrimeReactProvider>
  </React.StrictMode>,
)
